import './DashboardSimpleContent.scss';
import classnames from "classnames";
import { ByzzerMask } from "@/components/ByzzerMask/ByzzerMask";

const baseClassName = 'dashboard-content';

type DashboardSimpleContentProps = {
    className?: string;
    children: React.ReactNode;
    loading?: boolean;
}

export function DashboardSimpleContent({ 
    className, 
    children,
    loading = false, 
    ...props 
}: DashboardSimpleContentProps) {

    return (
        <div className={classnames(baseClassName, className)} {...props}>
            <ByzzerMask show={loading} loading={loading} />
            {children}
        </div>
    )
}

export default DashboardSimpleContent;
